<template>
  <div v-editable="blok" class="toast">
    <div class="toast__container">
      <div class="toast__wrapper">
        <div
          v-if="blok.image?.filename"
          class="toast__image-wrapper"
          :style="{ backgroundColor: blok.image_bg_color.value }"
        >
          <BaseNuxtImage
            class="toast__image"
            :src="blok.image.filename"
            :alt="blok.image.alt || ''"
          />
        </div>
        <div class="toast__content">
          <StoryblokComponent
            v-for="childBlok in blok.content"
            :key="childBlok._uid"
            v-editable="blok"
            :blok="childBlok"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { SbToastStoryblok } from '@/types'
interface Props {
  blok: SbToastStoryblok
}
defineProps<Props>()
</script>

<style lang="scss" scoped>
.toast {
  display: flex;
  justify-content: center;

  &__wrapper {
    @include shadow-flat-soft;

    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: var(--white);
    border-radius: 10px;
    border: 1px solid var(--gray-300);
    width: fit-content;
    height: 100%;
    overflow: hidden;
  }

  &__image-wrapper {
    display: flex;
    align-items: flex-end;
    height: 100%;
    flex-shrink: 0;
    width: 72px;
    @media (min-width: $breakpoint-lg) {
      width: 116px;
    }
  }

  &__image {
    width: 100%;
    height: auto;
  }

  &__content {
    padding: 24px;

    @media (min-width: $breakpoint-lg) {
      padding: 32px 48px;
    }
  }
}
</style>
